import OrderInfoForm from "./OrderInfoForm";

const Cart = () => {
    return (
        <div>
        <h3 style={{textAlign: 'center'}}> Personal Info</h3>
            <OrderInfoForm></OrderInfoForm>
        </div>
    )
}
export default Cart;